import { useT } from '../../../../i18n';
import { NHAN_KENH } from '../../constants-bot';
import { useDanhSachGiong } from '../../hooks/useChung';
import { CHE_DO_GIAO_TIEP } from '../../types';
import { ChonGiongBot } from './ChonGiongBot';
import { Khoi, NutLuaChon, type TabProps } from './chung';

export function TabGiaoTiep({ f, dat, suaDuoc }: TabProps) {
  const { t } = useT();
  // Danh sách giọng lấy từ MÁY CHỦ, không ghim cứng: danh mục đổi theo việc có khoá Gemini hay không, và một danh sách
  // ghim cứng sẽ hiện những mục chọn vào thì không kêu.
  const dsGiong = useDanhSachGiong();

  return (
    <Khoi>
      {/*
        Kênh giao tiếp — MỘT công tắc, hai chiều tiếng. Hai công tắc rời cho bốn tổ hợp mà hai trong bốn không ai muốn;
        ba mục dưới đây là ba tổ hợp CÓ NGHĨA. Chữ luôn hiện ở cả ba.
      */}
      <div>
        <p className="mb-1.5 text-xs font-medium text-content-secondary">{t('troLyAiBot.kenhGiaoTiep')}</p>
        <div className="grid gap-2 sm:grid-cols-3">
          {CHE_DO_GIAO_TIEP.map((m) => (
            <NutLuaChon
              key={m}
              chon={f.cheDoGiaoTiep === m}
              tat={!suaDuoc}
              nhan={t(NHAN_KENH[m].nhan)}
              mo={t(NHAN_KENH[m].mo)}
              onChon={() => dat('cheDoGiaoTiep', m)}
            />
          ))}
        </div>
        <p className="mt-1 text-xs text-content-muted">{t('troLyAiBot.kenhGhi')}</p>
      </div>

      {/*
        Giọng đọc nằm ở bản khai BOT, không phải lựa chọn của người dùng: khung chat nhúng chạy trên trang khách hàng, người
        nghe là khách vãng lai và không có chỗ nào để chọn. Bỏ trống hợp lệ — máy chủ lấy giọng đầu danh sách.
      */}
      {f.cheDoGiaoTiep !== 'van_ban' ? (
        <div>
          <p className="mb-1.5 text-xs font-medium text-content-secondary">{t('troLyAiBot.giongDoc')}</p>
          <ChonGiongBot danhSach={dsGiong} giong={f.giong ?? ''} onDoi={(v) => dat('giong', v)} tat={!suaDuoc} />
          <p className="mt-1.5 text-xs text-content-muted">
            {dsGiong.length ? t('troLyAiBot.giongGhi') : t('troLyAiBot.giongChuaCo')}
          </p>
        </div>
      ) : null}
    </Khoi>
  );
}
